module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>Welcome IP user!</h3>    \r\n    <p>This is what it means to be IP rec'd ....</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-ipuser.html
// module id = 380
// module chunks = 1